import { httpClient } from "../http/httpClient";

export type CrefazCltContextType =
  | "sexo"
  | "estadoCivil"
  | "grauInstrucao"
  | "nacionalidade"
  | "tipoReferencia"
  | "tipoConta"
  | "tipoTelefoneExtra"
  | "banco"
  | "uf";

export type ContextItem = {
  id: number | string;
  nome: string;
  exigeConjuge?: boolean;
};

export type ContextResponse = {
  data: ContextItem[];
};

export async function getContext(type: CrefazCltContextType) {
  const { data } = await httpClient
    .get<ContextResponse>(`/crefaz-clt/context/${type}`)
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}

export type City = {
  cidadeId: number;
  cidadeNome: string;
  codigoIBGE: number;
  ufId: number;
  uf: string;
};

export type CitiesResponse = {
  data: City[];
};

export type GetCitiesParams = {
  uf: string;
  nomeCidade: string;
};

export async function getCities(params: GetCitiesParams) {
  const { data } = await httpClient
    .get<CitiesResponse>("/crefaz-clt/context/cidade", { params })
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
